export const updateShipmentLineCounter = event => {
    if (!event.target.matches?.('.add-shipments textarea')) {
        return;
    }

    const counter = event.target.closest('.add-shipments')?.querySelector('[data-line-counter]');

    if (!counter) {
        return;
    }

    const maximumLines = Number.parseInt(counter.dataset.maximumLines, 10);

    const lineCount = event.target.value
        .split(/\r\n|\r|\n/)
        .filter(line => line.trim() !== '')
        .length;

    counter.textContent = counter.dataset.text
        .replace(':count', String(lineCount))
        .replace(':maximum', String(maximumLines));

    counter.classList.toggle('is-over', lineCount > maximumLines);
    counter.classList.toggle('is-nearing', lineCount <= maximumLines && lineCount >= Math.floor(maximumLines * 0.9));
};
